import React, { useEffect, useState } from 'react';
import styles from './DownloadApp.module.scss';
import { getOSName } from '@/helpers/props';
import Link from 'next/link';
import Image from 'next/image';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
const stores = [{
  href: 'https://cafebazaar.ir/app/travel.shab',
  src: '/images/footer/bazar-new.png',
  alt: 'cafebazaar',
  width: 56,
  height: 33
}, {
  href: 'https://myket.ir/app/travel.shab',
  src: '/images/footer/myket.png',
  alt: 'cafebazaar',
  width: 56,
  height: 33
}, {
  href: 'https://play.google.com/store/apps/details?id=travel.shab',
  src: '/images/footer/googleplay.png',
  alt: 'google play',
  width: 58,
  height: 33
}, {
  href: 'https://sibapp.com/applications/Shab',
  src: '/images/footer/sibapp-new.png',
  alt: 'sib app',
  width: 80,
  height: 40
}, {
  href: 'https://sibirani.com/apps/Shab',
  src: '/images/footer/sibirani.webp',
  alt: 'sib irani',
  width: 80,
  height: 40
}, {
  href: 'https://anardoni.com/ios/app/travelshab',
  src: '/images/footer/anardooni-new.svg',
  alt: 'anardooni app',
  width: 81,
  height: 24
}];
const DownloadApp = () => {
  const [isWeb, setIsWeb] = useState(true);
  useEffect(() => {
    if (getOSName() !== 'web') {
      setIsWeb(false);
    }
  }, []);
  return isWeb && <Box className={styles['container']}>
        <Box className={styles['wrapper']}>
          <Typography component={'h4'} variant={'title'}>
            دانلود اپلیکیشن
          </Typography>
          <Box className={styles['stores-container']}>
            {stores.map((item, index) => {
          return <Link key={'STORE_ITEM_' + index} target="_blank" rel="noreferrer" href={item.href} className={styles['store-item']} passHref>
                  <Image src={item.src} width={item.width} height={item.height} alt={item.alt} loading={'lazy'} />
                </Link>;
        })}
          </Box>
        </Box>
      </Box>;
};
export default DownloadApp;